import React from 'react'

// Sentius are grouped by element
// const groupedByElement = {
//   aer: [{id:1, name: 'Maguma', ...}, {...}],
//   magma: [{id:51, name: 'Aerl', ...}, {...}]
// }

function combineGroupedSentius(groupedSentius, elementsList) {
  const arrLengths = []
  const sentiusList = []
  for (const key in groupedSentius) {
    if (groupedSentius.hasOwnProperty(key)) {
      const value = groupedSentius[key]
      if (Array.isArray(value)) {
        arrLengths.push(value.length)
      }
    }
  }
  const maxLength = Math.max(...arrLengths)

  for (let i = 0; i < maxLength; i += 1) {
    // randomize elementsList so we always get all of elements one after another
    // but never repeat the same order
    elementsList
      .sort(() => 0.5 - Math.random())
      .forEach(e => {
        const currentElemItem = groupedSentius[e]
        if (currentElemItem) {
          const currentLength = currentElemItem.length
          // make sure that current sentius group has enough items in the list
          if (currentLength >= i) {
            const currSentius = groupedSentius[e][i]
            if (currSentius) sentiusList.push(groupedSentius[e][i])
          }
        }
      })
  }

  return sentiusList
}

// requires a list of sentius & elementsList
// elementsList = ['aer', 'maguma', ...]
const randomizeSentius = async (sentiusList, elementsList) => {
  let randomSentiusList = []
  if (sentiusList && sentiusList.length > 0) {
    const groupedByElement = {}
    // loop through all sentius
    await sentiusList
      .sort(() => 0.5 - Math.random())
      .forEach(async item => {
        // If sentius has more than 1 element randomly select one element and add it to that group of sentius
        if (item.element.length > 1) {
          const randomIndex = Math.round(Math.random())
          const randomElement = item.element[randomIndex]
          const slug = randomElement.slug
          // if element group doesn't exist create it
          if (!groupedByElement[slug]) {
            groupedByElement[slug] = []
          }
          // then push this item to this element group
          groupedByElement[slug].push(item)
        } else {
          // if only one element
          const slug = item.element[0].slug
          if (!groupedByElement[slug]) {
            groupedByElement[slug] = []
          }
          groupedByElement[slug].push(item)
        }
        return
      })

    randomSentiusList = combineGroupedSentius(groupedByElement, elementsList)
  }
  return randomSentiusList
}

export default randomizeSentius
